const styles = () => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});

export default styles;
